import { PriceType } from "../../../app/reducers/settingsReducer"
import { calcPriceForOzon } from "./calcPriceForOzon"
import { calcPriceForYandex } from "./calcPriceForYandex"
import { calcPriceWithSizes } from "./calcPriceWithSizes"
import { defaultCalcPrice } from "./defaultCalcPrice"
import { defaultCalcPrice2 } from "./defaultCalcPrice2"

export type CalcFn = (
  props: PriceType & {
    price?: number
    liters?: number
    weight?: number
  },
) => { price: number; old_price: number }

export const getCalcByIdent = (ident: string): CalcFn => {
  switch (ident) {
    case "with_sizes_1":
      return calcPriceWithSizes
    case "default2":
      return defaultCalcPrice2
    case "ozon":
      return calcPriceForOzon
    case "yandex":
      return calcPriceForYandex
    case "default1":
    default:
      return defaultCalcPrice
  }
}
